export const translations = {
	'Invalid child': {
		en: 'Invalid node',
		no: 'ugyldig node',
	},
	'This change needed confirmation': {
		en: 'This change needed confirmation',
		no: 'Denne endringen krever bekreftelse',
	},
	'This change will clear the following properties: ': {
		en: 'This change will clear the following properties: ',
		no: 'Denne endringen vil fjene følgende innstillinger: ',
	},
	'Create new authentication': {
		en: 'Create new authentication',
		no: 'Opprett ny autentisering',
	},
	'Show advanced tooltip': {
		en: 'Show advanced options. Advanced settings remain active even when hidden.',
		no: 'Vis avanserte alternativer. Avanserte innstillinger forblir aktive selv når de er skjult.',
	},
	'Show advanced': {
		en: 'Show advanced',
		no: 'Vis avansert',
	},
	'Hide advanced': {
		en: 'Hide advanced',
		no: 'Skjul avansert',
	},
	'Delete selected item?': {
		en: 'Delete selected?',
		no: 'Slett valgt?',
	},
	'Delete selected items?': {
		en: 'Delete selected?',
		no: 'Slett valgt?',
	},
	'Reset to Defaults': {
		en: 'Reset to default',
		no: 'Tilbakestill til standard',
	},
	'Test configuration': {
		no: 'Test konfigurasjon',
		en: 'Test configuration',
	},
	'Run query': {
		en: 'Query',
		no: 'Spør',
	},
	'Query and set result to field': {
		en: 'Query performs a request and adds the result to the field',
		no: 'Spør gjør en spørring og setter resultatet i feltet',
	},
	'Query and show result in popup': {
		en: 'Query performs a request and shows the result in a popup form',
		no: 'Spør henter data og viser innholdet i en popup',
	},
	'Query result can be edited. On update it will replace current content of {0}.': {
		en: 'The {0} can be edited. On update it will replace current content of {0}.',
		no: '{0} kan editeres. Når du oppdaterer vil det erstatte nåværende innhold av {0}',
	},
};
